import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function Cancel() {
  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', backgroundColor: '#0d121f', color: 'white' }}>
      <Row>
        <Col className="text-center">
          <div className="p-5" style={{
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '16px',
            border: '1px solid rgba(255, 255, 255, 0.1)',
          }}>
            <h1 className="gradient-text mb-3">Payment Canceled</h1>
            <p className="text-muted mb-4">
              Your payment process was canceled. You have not been charged.
            </p>
            <Button as={Link} to="/" variant="warning">
              Back to Homepage
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
} 